const compareProperties = (p1 = 0, p2 = 0) => p1 < p2 ? -1 : (p2 < p1 ? 1 : 0)

export const wheelSortFunction = (w1, w2) => {
    const compareDiameter = compareProperties(w1.diameter, w2.diameter)
    const compareOriginalWidth = compareProperties(w1.originalWidth, w2.originalWidth)
    const compareWidth = compareProperties(w1.width, w2.width)

    return compareDiameter || compareOriginalWidth || compareWidth || 0    
}